import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const EmptyMessage = () => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="titleS">{t('No hay criterios de visibilidad todavía.')}</Text>
      <Text type="bodyMRegular">{t('Crea tu primer criterio para controlar qué bloques ve cada cliente.')}</Text>
    </Styles.Container>
  )
}

export default EmptyMessage
